/* eslint-disable angular/window-service */
/* eslint-disable angular/timeout-service */
/* eslint-disable angular/document-service */
angular.module('tgaAdmin').controller('UsersController', [
  '$scope',
  '$state',
  '$filter',
  '$timeout',
  'userService',
  'modalService',
  'divisionService',
  'reportService',
  'settingsService',
  'constants',
  '$log',
  '$translate',
  '$uibModal',
  'domainService',
  function (
    $scope,
    $state,
    $filter,
    $timeout,
    userService,
    modalService,
    divisionService,
    reportService,
    settingsService,
    constants,
    $log,
    $translate,
    $uibModal,
    domainService,
  ) {
    $scope.data = {
      alerts: [],
      isSuperAdmin: userService.checkUserType(['super_admin']),
      isSalesAdmin: userService.checkUserType(['sales_admin']),
      userTypes: constants.userTypes(
        !(domainService.domain === 'tga' || domainService.domain === 'tga-qa') &&
          !userService.checkUserType(['super_admin', 'creator_admin', 'support_admin', 'sales_admin', 'viewer_admin']),
      ),
      datePickerOptions: settingsService.getDatePickerOptions(
        {},
        {
          'apply.daterangepicker': function (ev, picker) {
            $scope.viewmodel.range = picker.chosenLabel;

            if (
              !$scope.viewmodel.dateRange.startDate.isSame($scope.viewmodel.oldRange.startDate, 'day') ||
              !$scope.viewmodel.dateRange.endDate.isSame($scope.viewmodel.oldRange.endDate, 'day')
            ) {
              $scope.viewmodel.dateRange = $scope.viewmodel.oldRange = {
                startDate: picker.startDate,
                endDate: picker.endDate,
              };
              $scope.actions.loadUsers($scope.currTableState);
            }
          },
          'outsideClick.daterangepicker': function () {
            $scope.viewmodel.dateRange = {
              startDate: $scope.viewmodel.oldRange.startDate,
              endDate: $scope.viewmodel.oldRange.endDate,
            };
          },
        },
      ),
    };

    $scope.viewmodel = {
      users: [],
      user: null,
      range: 'Last 30 Days',
      oldRange: {
        startDate: moment().subtract(29, 'days'),
        endDate: moment(),
      },
      dateRange: {
        startDate: moment().subtract(29, 'days'),
        endDate: moment(),
      },
    };

    $scope.initialize = function () {
      $scope.viewmodel.user = null;

      divisionService.getDivisions().then((divisions) => {
        $scope.data.divisions = divisions;
      });

      settingsService.getSettings().then((settings) => {
        $scope.data.settings = settings;
        $scope.data.datePickerOptions.ranges['All Time'] = [moment(settings.date_created).startOf('month'), moment()];
      });
    };

    $scope.actions = {
      loadUsers(tableState) {
        $scope.loading = true;
        if (tableState) $scope.currTableState = tableState;

        const params = tableState
          ? {
              paginate: true,
              page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
              limit: tableState.pagination.number,
              sort: tableState.sort.predicate,
              order: tableState.sort.reverse ? 'desc' : 'asc',
              start_date: $scope.viewmodel.dateRange.startDate.toISOString(true),
              end_date: $scope.viewmodel.dateRange.endDate.toISOString(true),
            }
          : {};

        if (tableState?.search?.predicateObject) {
          Object.keys(tableState.search.predicateObject).forEach((key) => {
            // Check for divisions first and set values to a divisions array
            if (key === 'divisions') {
              params['divisions[]'] = Object.keys(tableState.search.predicateObject.divisions).map(
                (divisionKey) => tableState.search.predicateObject.divisions[divisionKey].value,
              );
            } else {
              params[key] = tableState.search.predicateObject[key];
            }
          });
        }

        userService.getUsers(params).then((response) => {
          $scope.loading = false;
          // Check for paginated response coming from `items` before falling back to the response
          $scope.viewmodel.users = response.items || response;

          if (tableState) {
            tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
            tableState.pagination.totalItemCount = response.total;
          }
        });
      },
      addUser(form) {
        $scope.actions.clearAlerts();

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        form.processing = true;

        userService.addUser($scope.viewmodel.user).then(
          () => {
            $scope.actions.createAlert('<span class="fa fa-check"></span> User added.', 'success');
            form.processing = false;
            $scope.initialize();
          },
          (error) => {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
            );
            form.processing = false;
          },
        );
      },
      sendInvitation(user) {
        $scope.actions.clearAlerts();

        user.sending = true;

        userService.sendInvitation(user.id).then(
          () => {
            $scope.actions.createAlert('<span class="fa fa-check"></span> Invitation sent.', 'success');
            user.sending = false;
          },
          (error) => {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
            );
            user.sending = false;
          },
        );
      },

      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });

        $scope.timer = $timeout(() => {
          $scope.data.alerts.splice($scope.data.alerts.length - 1, 1);
        }, 5000);
      },
      clearAlerts() {
        $scope.data.alerts = [];

        if ($scope.timer) {
          $timeout.cancel($scope.timer);
        }
      },
      exportUsers() {
        if (!$scope.viewmodel.users.length) {
          return false;
        }

        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-users-report.html',
            controller: 'UsersReportModalController',
            backdrop: true,
            resolve: {
              extras() {
                return {
                  report: {
                    report_type: 'users_report',
                    start_date: $scope.viewmodel.dateRange.startDate.toISOString(true),
                    end_date: $scope.viewmodel.dateRange.endDate.toISOString(true),
                  },
                };
              },
            },
          })
          .result.catch(angular.noop);
      },
    };

    $scope.initialize();
  },
]);
